module.exports = __webpack_public_path__ + "img/ommax-voices-4.aa31e080.jpg";